// import { useCallback } from 'react';
// import { Box, VisuallyHidden } from '@chakra-ui/react';
// import { GraphQLReqStatus } from '@gamma/ui/progress';
// import { SortingRule } from 'react-table';
// import { Detection } from '@investigator/shared/generated/graphql';
// import { useDetectionSummaryContext } from '../../../../detections/context/DetectionSummaryContext';
// import { DetectionsTableView } from '../../../../detections/components/DetectionsTableView';
// import { ApexDetectionsChart } from '../../../../detections/pages/DetectionDetails/Components/RelatedDetections/Components/RelatedDetectionsChart/ApexDetectionsChart';
// import { i18n } from '@investigator/shared/localization';

// const { detectionsActivity, detectionsTimelineChart, detectionsListTable } =
//   i18n.pages.entities.detectionSummaryInformation;

/**
 * TEMPORARILY DISABLED: Detection timeline and table hidden due to issues.
 * To re-enable, uncomment the code below.
 */
export const DetectionsActivity = (): JSX.Element | null => {
  return null;

  // const {
  //   entityDetectionsActivityTimelineInterval,
  //   setEntityDetectionsActivityTimelineInterval,
  //   entityDetectionsActivityTimelineStart,
  //   entityDetectionsActivityTimelineEnd,
  //   entityDetectionsActivityTimelineSummaryData,
  //   entityDetectionsActivityTimelineSummaryLoading,
  //   entityDetectionsActivityTimelineSummaryError,
  //   entityDetectionsActivityLoading,
  //   entityDetectionsActivityError,
  //   entityDetectionsActivityPageIndex,
  //   entityDetectionsActivityPageSize,
  //   entityDetectionsActivityPageCount,
  //   entityDetectionsActivityOffset,
  //   entityDetectionsActivityDateRangeChangeKey,
  //   handleEntityDetectionsActivityPageChange,
  // } = useDetectionSummaryContext();

  // const params = new URLSearchParams();

  // const handleFetchData = useCallback(
  //   (newPageIndex: number, newPageSize: number) => {
  //     handleEntityDetectionsActivityPageChange(newPageIndex, newPageSize);
  //   },
  //   [handleEntityDetectionsActivityPageChange],
  // );

  // const formatSort = useCallback((value: string) => {
  //   const [id, direction] = value.split(':');
  //   return [{ id, desc: direction === 'desc' }];
  // }, []);

  // const getSortsForAPI = useCallback((sorts: SortingRule<Detection>[]) => {
  //   return sorts.map((sort) => ({
  //     sort_by: sort.id,
  //     sort_dir: sort.desc ? 'desc' : 'asc',
  //   }));
  // }, []);

  // if (
  //   entityDetectionsActivityLoading &&
  //   !entityDetectionsActivityTimelineSummaryData
  // ) {
  //   return (
  //     <Box p={4} aria-live="polite" aria-busy="true">
  //       <GraphQLReqStatus error={undefined} loading={true} />
  //     </Box>
  //   );
  // }

  // if (entityDetectionsActivityError) {
  //   return (
  //     <Box p={4} role="alert" aria-live="assertive">
  //       <GraphQLReqStatus
  //         error={entityDetectionsActivityError}
  //         loading={false}
  //       />
  //     </Box>
  //   );
  // }

  // return (
  //   <Box>
  //     <Box mb={4} as="section" aria-labelledby="detections-timeline-heading">
  //       <VisuallyHidden id="detections-timeline-heading">
  //         {detectionsTimelineChart}
  //       </VisuallyHidden>
  //       {/* TIMELINE CHARTS */}
  //       {entityDetectionsActivityTimelineSummaryLoading &&
  //       !entityDetectionsActivityTimelineSummaryData ? (
  //         <Box p={4} aria-live="polite" aria-busy="true">
  //           <GraphQLReqStatus error={undefined} loading={true} />
  //         </Box>
  //       ) : entityDetectionsActivityTimelineSummaryError ? (
  //         <Box p={4} role="alert" aria-live="assertive">
  //           <GraphQLReqStatus
  //             error={entityDetectionsActivityTimelineSummaryError}
  //             loading={false}
  //           />
  //         </Box>
  //       ) : (
  //         <ApexDetectionsChart
  //           chartTitle={detectionsActivity}
  //           end={entityDetectionsActivityTimelineEnd}
  //           start={entityDetectionsActivityTimelineStart}
  //           maxRows={5}
  //           chartsData={entityDetectionsActivityTimelineSummaryData}
  //           interval={entityDetectionsActivityTimelineInterval}
  //           setInterval={setEntityDetectionsActivityTimelineInterval}
  //           latest_start_timestamp={entityDetectionsActivityTimelineEnd}
  //           showFilters={false}
  //           showInfoBanner={false}
  //           showCurrentDetectionSection={false}
  //           showSourceDestPairSection={false}
  //         />
  //       )}
  //     </Box>

  //     {/* DETECTIONS TABLE */}
  //     <Box as="section" aria-labelledby="detections-table-heading">
  //       <VisuallyHidden id="detections-table-heading">
  //         {detectionsListTable}
  //       </VisuallyHidden>
  //       <DetectionsTableView
  //         enableBulkSelection={true}
  //         offset={entityDetectionsActivityOffset}
  //         pageSize={entityDetectionsActivityPageSize}
  //         pageIndex={entityDetectionsActivityPageIndex}
  //         pageCount={entityDetectionsActivityPageCount}
  //         sort_by={null}
  //         params={params}
  //         detectionsLoading={entityDetectionsActivityLoading}
  //         formatSort={formatSort}
  //         handleFetchData={handleFetchData}
  //         getSortsForAPI={getSortsForAPI}
  //         dateRangeChangeKey={entityDetectionsActivityDateRangeChangeKey}
  //         hideNotesColumn={false}
  //         hideDetectionMethodColumn={false}
  //         hideAlertTypeColumn={true}
  //         hideAlertCountColumn={true}
  //         categoryColumnHeader="Category"
  //         disableDrawer={true}
  //       />
  //     </Box>
  //   </Box>
  // );
};
